import styled from 'styled-components';

export const Field = styled.div`
    margin: 12px auto 0;
    text-align: left;
    position: relative;

    &:first-of-type {
        margin-top: 0;
    }
`;
